import styled from "styled-components";
import { COLORS } from "../../../styles";

export const GoodListContainer = styled.div`
	position: relative;
	top: -6px;
	display: flex;
	flex-direction: column;
	flex: 1;
	background: ${COLORS.White};
	padding: 9px 38px 35px 26px;
	border-width: 1px 1px 0 1px;
	border-style: solid;
	border-color: #fff;
	border-radius: 4px 4px 8px 8px;
`;

export const ListProducts = styled.div`
	display: flex;
	column-gap: 10px;
	row-gap: 34px;
	flex-flow: wrap;
`;
